module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-43.3a3eae77.png";